import LocationService from 'external-services/location-service';
import { getBannerHeight } from 'app/common/header/bannerHeight';

/**
 * Note:
 * This file contains constants (not enums).
 * Enums can be found in app.types.ts.
 */

export const nbiSource = 'diary';

export const hardCodedTags = {
  DELIVERY_TAG_NAME: 'delivery-fee',
  DELIVERY_TAG_ID: 'delivery_fee',
  OTHER_TAG_TYPE: 'tagtype_other',
  SHARED_TAG_TYPE: 'tagtype_shared',
  VERIFIED_TAG_ID:'tag_verified',
  VERIFIED_TAG_NAME:'tag_verified'
};

export const sharedTagIds = {
  membership:'tag_membership',
  noShow:'tag_no_show',
  vip :'tag_vip'
}

export const DocumentTypes = {
  MenuOption: 'menuoption'
};

export const Providers = {
  NBI: 'NBI', // Now BookIt - Default
  EPO: 'EPO', // Easy Pre Order
};

export const AppCache = {
  UpdateCacheFrequency: 3600000, // Milliseconds, 3600000 = 1 hour
  ReloadDialogDismissLimit: 3, // How many times people can reject updates, 0 = no limit
};

export const Database = {
  CouchCheckFrequency: 900000, // Milliseconds, 900000ms = 15min
  CouchSyncCheckFrequency: 600000,   // Milliseconds, 600000ms = 10min - Used to define interval between dbSync verifications - NBI-2294
  ReplicateTimeout: 20000,      // Milliseconds, 20000 = 20secs
};

export const Dimensions = {
  headerHeight: 64,
  bookingsListNegHeight: 254,
  // COR-141 deprecation banner above the header: a getter, as the banner wraps on narrow screens (CLI-569)
  get bannerHeight() {
    return getBannerHeight();
  }
};

export const GLOBAL_ANGULARJS_HTTP_TIMEOUT = 60000;
export const GLOBAL_AXIOS_TIMEOUT = 60000;

// see webpackConfig -> DefinePlugin
export const appValues = {
  VERSION: VERSION, // defined in app-version.json (via webpack.DefinePlugin)
  VERSION_SHORT: VERSION.split('|')[0],
  ENVIRONMENT: window.config.environment,
  SKIP_CACHE: SKIP_CACHE,
  IS_LOCAL: IS_LOCAL
};

export const appURLS = {
  API: window.config.baseAPI,

  /**
   * 'api-login' gets used in web.configs to redirect to alternate server
   */
  API_LOGIN: '/api-login',

  /**
   * Telegraf database endpoint (DEV node 3 - couch).
   * Mau setup the influx db for PROD in one of the DEV couch linux boxes.
   * So yeah .. that box is no longer running (and it shouldn't have been deployed there to start with).
   */
  INFLUXDB: 'http://52.237.241.95:8086'
};

export const WALKIN_DEFAULT_NAME = 'Walk In';


// @todo: could be replaced by webpack.definePlugin (same as VERSION). severity: low
export const Environment = {
  Value: appValues.ENVIRONMENT || 'remote', // defaults to remote if ENV variable doesn't exist
  IsLocal: appValues.IS_LOCAL
};

export const PrefixNote = 'note_';

/**
 * Used in AngularJS HTML to prevent decimal places getting added to number inputs.
 * The 'a' allows users to still use the popular "select all" keyboard shortcut on Mac or PC.
 */
export const WHOLE_NUMBER_REGEX = (LocationService.isIOS() || LocationService.isAndroid()) ? '^[0-9]*$' : '^[0-9a]*$';

export const loadLimit = 30;

export const bookingListDefaultWidth = 306;
